#import "../../../calls/graphql/fragments/phone-integration-fields.graphql"
#import "./user-permissions-fragment.graphql"
#import "./widgets-collapsed-state-fragment.graphql"

fragment SessionUser on User {
    id
    firstName
    lastName
    name
    avatarUrl
    htmlUrl
    initials
    isAdministrator
    isSupport
    timezone
    sendableEmailAddresses {
        ...UserEmailAddress
    }
    emailAddresses {
        ...UserEmailAddress
    }
    emailSignature
    isEmailTrackingEnabled
    isExcludingTimelineInteractions
    isExcludingTimelineOutreach
    isExcludingTimelineCustomerJourneys
    hasDismissedCompanyUnlockConfirmation
    hasDismissedSchedulerPromotion
    hasViewedSchedulerOnboardingModal
    dismissedSettings
    completedWizards
    schedulerRootMeetingsUrl
    permissions {
        ...UserPermissionsFragment
    }
    agentStatus
    isMainSidebarCollapsed
    isAiAgentSidebarOpen
    numActiveChats
    numNeedsReplyChats
    clickToCallRecordingEnabled
    clickToCallTranscriptionEnabled
    clickToCallSummaryEnabled
    agentPresence
    hasUploadedAvatar
    hasDisabledShortcuts
    hasMfaToken
    zoomIntegration {
        isEnabled
    }
    googleMeetIntegration {
        isEnabledCalendarSync
        isEnabledMeetSync
    }
    microsoftTeamsIntegration {
        isEnabled
    }
    autoPresenceEnabled
    hasEnabledZoomAutolog
    hasEnabledGoogleMeetAutolog
    hasEnabledMicrosoftTeamsAutolog
    hasEnabledAircallAutolog
    hasEnabledCallRailAutolog
    hasEnabledRingCentralAutolog
    hasEnabledDialpadAutolog
    hasEnabledKixieAutolog
    hasAllowedGoogleMeetWebhookProcessing
    leadPageRedesignM1Enabled
    leadPageRedesignM3Enabled
    peepPagesRedesignEnabled
    widgetsCollapsedState {
        ...WidgetsCollapsedState
    }
    phoneCallerType
    phoneIntegrations {
        ...PhoneIntegrationFields
    }
    clickToCallIntegration {
        integrationType
        isEnabled
        phoneNumber
        callerId
        defaultCallsActivityType {
            id
            name
            icon
            isImmutable
        }
        defaultVoicemailsActivityType {
            id
            name
            icon
            isImmutable
        }
    }
}

fragment UserEmailAddress on UserEmail {
    id
    address
    formatted
    isSyncEnabled
    isEnabledForSending
}
